import React, { Component, Fragment } from 'react';
import ReturnPageHeader from "pages/returnCheckout/ReturnPageHeader" 
import shop from "shop/shop"
import {Button, Icon, Message, Modal, Form,Checkbox,Dropdown,TextArea} from "semantic-ui-react"
import queryString from "qs"
import ProductTable from "components/Product/ProductTableReturn"
import CartTotal from "components/Cart/CartTotal"
import Responsive from "react-responsive"
import { Link } from "react-router-dom"
import { SearchForm }              from "components/Search/SearchBarWithTypeahead"
import searchStore                 from "stores/searchStore"
import moment                               from "moment"
import ContactMessage from 'components/Messages/ContactMessage';
import LocalFooter from 'components/LocalFooter';
import _            from "lodash"
import categoryStore                                                                                 from "stores/categoryStore"
import cmsStore                                                                                      from "stores/cmsStore"
import productStore from "stores/productStore"
import ProductListItem from "components/Product/ProductListItem"
import ReturnPageProgress from './ReturnPageProgress';
import ProductFullscreen from "components/Product/ProductFullscreen"
import {
	Card,
	Col,
	FormField,
	FormInput,
	Row,Table
  } from "elemental-react16"
class ReturnPageQuantityAddons extends Component {
    state = {
        products: [],
        fullscreenElement: null,
        img_srcs: [],
        frachtkosten: true,
        productsTemp: [],
        navHeader: false,
        searchString: "",
        bausteinValue: "",
        newSeason: {
            season: {
                seasonActive: false,
                referenceNumber: "",
                email: "",
                start: "",
                end: "",
                name: ""
            }
        },
        productSearch: []
      }

      async componentDidMount() {
        await shop.cart.hooks.changed.add( this.updateCart )
        const bausteinSeason = await shop.cart.data.extras && shop.cart.data.extras.bausteinSeason ? shop.cart.data.extras.bausteinSeason : ""
        const bausteinValue = await shop.cart.data.extras && shop.cart.data.extras.bausteinValue ? shop.cart.data.extras.bausteinValue : ""
        await this.setState({ bausteinSeason, bausteinValue })
        await console.log("LOAD BAUSTEIN SEASON", bausteinSeason, bausteinValue, await shop.cart.data)
        await this.load()
        await console.log("LOAD products",this.state.products, shop.cart.data, this.props.history)
        
        if(!shop.delivery){
          console.log("shop.delivery is empty")
          //this.props.history.push("/return")
        }
        
      }
      
      handleChange = ( { product } ) => {
        //console.log("HANDLE CHANGE PRODUCT: ", product)
        shop.cart.add( product )
      }
      
      updateCart = () => {
        let products = getProducts()
        products = getProducts()
        this.setState( { products } )
        this.forceUpdate()
      }



      handleCheckForProductsInCart = async () => {
        let productInCart = false;
        await Promise.all(this.state.productSearch.map(async product => {
          if (shop.cart && shop.cart.data && shop.cart.data.positions) {
            productInCart = shop.cart.data.positions.find(position => position.article_id === product.map_id);
            if(productInCart !== false && productInCart !== undefined){
                product.count = productInCart.count
            }
          }
        }));
      }
      
      componentWillUnmount() {
        this.setState({productsTemp: shop.cart.products})
        shop.cart.hooks.changed.remove( this.updateCart )
      }

        async fetchCategoryPage( collectionId ) {
          try {
            let result = await shop.fetch( `/wp/wp-json/wp/v2/shop-category?slug=${collectionId}` )
            if ( result.length > 0 ) {
              this.setState( { categoryPage: result[ 0 ] } )
            } else {
              this.setState( { categoryPage: 0 } )
            }
          }
          catch (err) {
            console.error( "Error Fetching shop-category", err )
            this.setState( { categoryPage: 0 } )
          }
        }

        load = async ( props = this.props ) => {
          this.setState( { loading: true } )
          const query = queryString.parse( props.location.search.substr( 1 ) )
          const { categories = "" } = props.match.params
          const parentCategories = categories.split( "/" )
          let bausteinSeason = await shop.cart.getExtra( "bausteinSeason" )
          console.log( "LOAD PRODUCTS EXTRAS: ", bausteinSeason, await shop.cart.getExtra( "bausteinSeason" ))
          bausteinSeason = "Zusatz" + (bausteinSeason !== "" ? bausteinSeason : "Alle")
          console.log("LOAD PRODUCTS EXTRAS: ", bausteinSeason)
          const categoryId = bausteinSeason !== "" ? bausteinSeason : "Alle"
          const category = categoryStore.categoriesById.get( "Zusatz" + categoryId )
          console.log("LOAD CATEGORY",category, categoryId)
          // TODO: NOT EVERY CATEGORY STORE SUPPORTS THIS
          // categoryStore.fetchCategoryMeta && categoryStore.fetchCategoryMeta( categoryId )
          
          const { page = 1, count = shop.config.standards.ITEMS_PER_PAGE } = query
          let filters = []
          const fields = _.pick( query, shop.config.pickFilter )
          const filterSize = _.size( fields )
          
          _.forEach( fields, ( value, key ) => {
            
            // MULTIFILTERS ARE ADDED AS "OR"
            if ( Array.isArray( value ) ) {
              let queryFilters = value.map( v => {
                return {
                  op: "equals", extra: true, field: key, value: v
                }
              } )
              
              let combinedFilter = { "or": queryFilters }
              filters.push( combinedFilter )
              
            } else {
              let filter = {
                op: "equals", extra: true, field: key, value: value
              }
              filters.push( filter )
            }
          } )
          
          // Only hide variants if we don't search by filter
          // i.e. user searches for color only available on variants
          if ( cmsStore.config.plugin.hideVariants ) {
            // FILTER ALL VARIANTS (ONLY MAIN-ARTCILES)
            let noVariants = {
              op: "equals", field: "type", value: "1"
            }
            const singleItems = { "field": "mainArticle", "op": "equals", "value": "" } //CollectionPage mainArticle = mainart
            let combinedFilter = [{ "or": [singleItems, noVariants] }]
            filters = filters.concat( combinedFilter ) // this shows only mainarticles (i.e. no-variants))
          }
          
          if ( categoryId ) {
            this.fetchCategoryPage( categoryId )
            productStore.fromCategory( categoryId, {
              value: "%%",
              dir: query.dir || shop.config.standards.DIR || "des",
              sort: query.sort || shop.config.standards.SORT || "sort",
              page,
              count: 250 || shop.config.standards.ITEMS_PER_PAGE,
            }, filters ).then( res => {
              if ( !res.products.length ) {
                
                console.log("NO PRODUCTS FOUND FOR CATEGORY ID:", categoryId)
                let catQuery = {
                  value: "%%",
                  dir: query.dir || shop.config.standards.DIR || "des",
                  sort: query.sort || shop.config.standards.SORT || "sort",
                  page,
                  count: count || shop.config.standards.ITEMS_PER_PAGE,
                }
                
                let additionalFilters = filters.filter( e => e.field !== "type" )
                
                // console.info( "NO VARIANTS FOUND - FALLBACK TO 'SHOW ALL'" )
                return productStore.fromCategory( categoryId, catQuery, additionalFilters )
                                   .then( res => {
                                    console.log("RES",res)
                                     let { products } = res
                                     if ( products.length === 0 ) {
                                       if ( products.length === 0 && shop.config.collections.showProductsFromSubCategories ) {
                                         // get products from all child categories
                      
                                         const mapChildren = cat => {
                                           if ( cat.children.length > 0 ) return _.map( cat.children, mapChildren )
                                           return cat.map_id
                                         }
                      
                                         const ids = _.flatten( category && category.children.map( mapChildren ) )
                                         if ( ids.length > 0 ) {
                                           return productStore.fromCategory( ids, catQuery, additionalFilters )
                                         }
                                       }
                                     }
                                     return res
                                   } )
              }
              this.setState({ loading: false, products: res.products, productSearch: res.products })
              this.handleCheckForProductsInCart()
              return res
            } )
                        .then( res => {
                          let { products, meta = {}, fields, size } = res
                          fields = fields || meta.fields
                         // console.log( "NEW FILTER FIELDS", categoryId, Object.keys( fields ).length, { fields } )
                          this.setState( { products, category, fields, size, meta, filterCount: fields && fields.length, loading: false } )
                          return res
                        } )
          } else {
            productStore.query( {
                                  value: "%%",
                                  filter: [...filters],
                                  dir: query.dir || shop.config.filter_defaults.sort || "des",
                                  sort: query.sort || shop.config.filter_defaults.sort,
                                  page,
                                  count: count || shop.config.standards.ITEMS_PER_PAGE,
                                } )
                        .then( res => {
                          lastFilter = this.props.location.search
                          let { products, size } = res
                          this.setState( { products, size, filterCount: fields && fields.length, loading: false } )
                        } )
          }
        }
        	showFullscreen = ( element ) => {
		this.setState( {
			fullscreenElement: element
		} )
	}

    render() {
        const { referer = "/", ...query } = queryString.parse( location.search, { ignoreQueryPrefix: true } )
        let { products, productSearch, bausteinValue, fullscreenElement, img_srcs } = this.state


        //console.log("SHOP RETURN: ", shop.return)
        const handleChangeSearchString = (event) => {
            console.log("SEARCH CHANGE: ", event.target)
            this.setState({productSearch: []})
            for(let i = 0; i < this.state.products.length; i++){
                if(this.state.products[i].article_nr.includes(event.target.value) || 
                    this.state.products[i].desc.short_des.toUpperCase().includes(event.target.value.toUpperCase()) || 
                    this.state.products[i].barcode.includes(event.target.value) ||
                    (this.state.products[i].cats[0] && this.state.products[i].cats[0].cat_id && this.state.products[i].cats[0].cat_id.includes(event.target.value)) ||
                    (this.state.products[i].extras && this.state.products[i].extras.category && this.state.products[i].extras.category.includes(event.target.value)) ||
                    (shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.rewe_extra && shop.session.value.extras.rewe_extra == "Ja" &&
                        this.state.products[i].extras && this.state.products[i].extras.rewe_nan && this.state.products[i].extras.rewe_nan.value.value.includes(event.target.value))) {
                    this.setState(prevState => ({
                        productSearch: [...prevState.productSearch, this.state.products[i]]
                    }));
                    //console.log("RETURN SEARCH CHANGE CORRECT", this.state.products[i])
                }
            }
            this.setState({searchString: event.target.value})
          }; 
        const handleClearSearchString = () => {
            this.setState({productSearch: products, searchString: ""});
        }
    
        const handleCommentChange = ( event ) => {
        console.log("VALUE:",event.target)
        let comment = event.target.value
        this.setState(prevState => {
            let newcust = { ...prevState.newcust };  
            newcust.contact.comment = comment;       
            return { newcust }; 
            })
        }

        return (
            <Fragment>
                <section className="container pt2 pb2">
                    <ReturnPageProgress progress={1} />
                </section>
                <ProductFullscreen
                    change={this.showFullscreen}
                    images={img_srcs}
                    image={fullscreenElement} />
            <Responsive minWidth={790} >
            <div>
            <Table style={{border: "none"}}>
            <colgroup>
                <col width="10%" />
                <col width="12%" />
                <col width="3%" />
                <col width="55%" />
            </colgroup>
            <tbody>
                <tr>
                <td>
                    &nbsp;
                </td>
                <td className="pr4  pl4 v-top ReturnPageAlignment" >
                    <ReturnPageHeader className="v-top" activeStep={1} />
                </td>
                <td>
                    &nbsp;
                </td>
                <td className="pr4  pl4 v-top ReturnPageAlignment" >
                    <h1 style={{color:"#337ab7", fontSize:40}}  className="pt5 tl"><b>Zusatzsortimente</b></h1>
                    
                    <ContactMessage />
                    {/*                    <Message style={{width: "80%"}}>
                    <div>{translate( `Bitte tragen Sie den aktuellen Restbestand der Lindt Saison ${this.state.newSeason.season.name} in die untenstehende Erfassungsmaske bis zum `)}<span className="b" style={{color:"red"}}>{this.state.newSeason.season.end || "01.01.2025"}</span>{translate(" ein.")}</div>
                    </Message> */}

 
                    
                    {/*                    <br/>
                    {shop.session && shop.session.value && shop.session.value.extras && !shop.session.value.extras.rewe_extra && <Fragment>
                    <div className="pb3" style={{color:"#337ab7", fontSize:20}} >Zähl Unterstützung  </div>
                    <div className="pb3 bb b--black-10 " style={{width: "80%"}}>
                    {
                        <Button primary onClick={() => {window.open(`${shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.rewe_extra && shop.session.value.extras.rewe_extra == "Ja" ? "/Restantenschein Ostern 2025 - digital.pdf" : "/Restantenschein Ostern 2025 - digital.pdf"}`, "_blank")}}>{translate( "PDF herunterladen" )}</Button>}
                    </div>
                    </Fragment>}
                    <div className="pb2 pt3" style={{color:"#337ab7", fontSize:20}}>Produktsuche</div>
                    <div className="headerInline">
                    <FormInput
                    Icon="search"
                    style={{ width: "75%" }}
                    className={""}
                    value={this.state.searchString}
                    onChange={handleChangeSearchString} icon="search" placeholder={translate( `Suche nach Artikelnummer, ${shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.rewe_extra && shop.session.value.extras.rewe_extra == "Ja" ? "Rewe NAN," : ""} EAN oder Beschreibung` ) + " ..."}>
                    </FormInput>
                    <Button onClick={handleClearSearchString} style={{backgroundColor: "#ffffff", maxWidth:"55px"}} >
                    <Icon name="close"></Icon>
                    </Button>
                    </div>
                    <div className="pb2 pt3" style={{color:"#337ab7", fontSize:20}}>Kategorie</div>
                                       <div className="pb3">
                        <table className="w-80">
                            <colgroup>
                                <col width="25%" />
                                <col width="25%" />
                                <col width="25%" />
                                <col width="25%" />
                            </colgroup>
                            <tbody>
                            <tr className="tc pl2 pr2">
                                <td className={this.state.searchString === "Saison" ? "selectedCategory pl2 pr2 tc" : "tc pl2 pr2"}>
                                    <Button style={{minWidth: "150px"}} primary onClick={() => { 
                                        this.setState({ searchString: "Saison" }, () => {
                                            const event = { target: { value: "Saison" } };
                                            handleChangeSearchString(event);
                                        });
                                    }} >Gesamt Saison</Button>
                                </td>
                                <td className={this.state.searchString === "HELLO" ? "selectedCategory pl2 pr2 tc" : "tc pl2 pr2"}>
                                    <Button style={{minWidth: "150px"}} primary onClick={() => { 
                                        this.setState({ searchString: "HELLO" }, () => {
                                            const event = { target: { value: "HELLO" } };
                                            handleChangeSearchString(event);
                                        });
                                    }} >HELLO</Button>
                                </td>
                                <td className={this.state.searchString === "C+C Ware" ? "selectedCategory pl2 pr2 tc" : "tc pl2 pr2"}>
                                    <Button style={{minWidth: "150px"}} primary onClick={() => { 
                                        this.setState({ searchString: "C+C Ware" }, () => {
                                            const event = { target: { value: "C+C Ware" } };
                                            handleChangeSearchString(event);
                                        });
                                    }} >C+C Ware</Button>
                                </td>
                                <td className={this.state.searchString === "lose Ware" ? "selectedCategory pl2 pr2 tc" : "tc pl2 pr2"}>
                                    <Button style={{minWidth: "150px"}} primary onClick={() => { 
                                        this.setState({ searchString: "lose Ware" }, () => {
                                            const event = { target: { value: "lose Ware" } };
                                            handleChangeSearchString(event);
                                        });
                                    }} >lose Ware</Button>
                                </td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}
                    <div className="pb3 pt3">
                    {/*<OrderDetailTable products={shop.delivery[0].positions} />*/}
                    {/*<ProductTable cart={shop.cart} onChange={this.handleChange} products={productSearch}/>*/}

                    </div>
                    <div className="w-80 pt3 pb3">
                    {productSearch.map( ( product, index ) => <ProductListItem
                                      history={this.props.history}
                                      index={index}
                                      key={product.map_id}
                                      product={product}
                                      additionalArticle={true}
                                      /> )}
                    </div>
                </td>
                </tr>
                {/*                <tr>
                <td>
                    &nbsp;
                </td>
                <td>
                    &nbsp;
                </td>
                <td>
                    &nbsp;
                </td>
                </tr>
                <tr>
                <td>
                &nbsp;
                </td>
                <td>
                    &nbsp;
                </td>
                <td>
                    &nbsp;
                </td>
                <td>
                    <div style={{paddingTop: "50px",width: "80%"}} className="">
                    <Link to={{
                    pathname: `/return`,
                    search  : this.props.location.search
                    }}>
                    <Button
                    primary >
                    {translate( "Zurück" )}
                    <i className="icon-angle-right"/>
                    </Button>
                    </Link>
                    <Button
                        className="fr"
                        disabled={false}
                        primary
                        onClick={() => {this.props.history.push("/return/contactPerson")}}
                        >{translate( "Display bestätigen" )}</Button>
                    </div>
                </td>
                </tr> */}
                </tbody>
            </Table>
            </div>
            </Responsive>    
            <Responsive maxWidth={789} >
            <table>
            <colgroup>
                <col width="90%" />
            </colgroup>
            <tbody>
                <tr className="bb b--black-10">
                <td>
                <div className="headerInline"><Button style={{backgroundColor: "#ffffff", maxWidth:"55px"}} 
                    onClick={() => (this.state.navHeader ? this.setState({navHeader : false}) : this.setState({navHeader : true}
                    ))}>
                    <Icon className="big bars tc" ></Icon>
                    </Button><span className="pt3 tc fw7 f2">Restanten</span> 
                    </div>
                {this.state.navHeader && <ReturnPageHeader className="v-top" activeStep={1} />}
                </td>
                </tr>
                <tr className="tc">
                <td className="tc pr2  pl2 v-top ReturnPageAlignment" >
                {/*<td className="pr4  pl4 v-top ReturnPageAlignment" >
                    
                </td>*/}
                    <h1 style={{color:"#337ab7", fontSize:40}}  className="tc"><b>Zusatzsortimente</b></h1>
                    
                    <ContactMessage />
                    {/*                    <Message >
                    <div>{translate( `Bitte tragen Sie den aktuellen Restbestand der Lindt Saison ${this.state.newSeason.season.name} in die untenstehende Erfassungsmaske bis zum `)}<span className="b" style={{color:"red"}}>{this.state.newSeason.season.end || "01.01.2025"}</span>{translate(" ein.")}</div>
                    </Message>
                    <br/>
                    {shop.session && shop.session.value && shop.session.value.extras && !shop.session.value.extras.rewe_extra && <Fragment><div className="pb3" style={{color:"#337ab7", fontSize:20}} >Zähl Unterstützung  </div>
                    <div className="pb3 bb b--black-10">
                    {shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.rewe_extra && shop.session.value.extras.rewe_extra != "Ja" && 
                        <Button primary onClick={() => {window.open("/Restantenschein-Weihnachten2024-digital.pdf", "_blank")}}>{translate( "PDF herunterladen" )}</Button>}
                    {shop.session && shop.session.value && shop.session.value.extras && !shop.session.value.extras.rewe_extra &&
                        <Button primary onClick={() => {window.open("/Restantenschein Ostern 2025 - digital.pdf", "_blank")}}>{translate( "PDF herunterladen" )}</Button>}
                    </div>
                    </Fragment>}
                    <div className="pb2 pt3" style={{color:"#337ab7", fontSize:20}}>Produktsuche</div>
                    <div className="headerInline">
                    <FormInput
                    Icon="search"
                    style={{ width: "95%" }}
                    className={""}
                    value={this.state.searchString}
                    onChange={handleChangeSearchString} icon="search" placeholder={translate( "Suche nach Artikelnummer, EAN oder Beschreibung" ) + " ..."}>
                    </FormInput>
                    <Button onClick={handleClearSearchString} style={{backgroundColor: "#ffffff", maxWidth:"55px"}} >
                    <Icon name="close"></Icon>
                    </Button>
                    </div>
                    <div className="pb2 pt3" style={{color:"#337ab7", fontSize:20}}>Kategorie</div>
                    <div className="pb3">
                        <table className="w-80">
                            <colgroup>
                            <   col width="25%" />
                                <col width="25%" />
                                <col width="25%" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    &nbsp;
                                </tr>
                            <tr className="tc pl2 pr2">
                                <td className={this.state.searchString === "Saison" ? "selectedCategory pl2 pr2 tc" : "tc pl2 pr2"}>
                                    <Button style={{minWidth: "170px"}} primary onClick={() => { 
                                        this.setState({ searchString: "Saison" }, () => {
                                            const event = { target: { value: "Saison" } };
                                            handleChangeSearchString(event);
                                        });
                                    }} >Gesamt Saison </Button>
                                </td>
                                <td className={this.state.searchString === "HELLO" ? "selectedCategory pl2 pr2 tc" : "tc pl2 pr2"}>
                                    <Button style={{minWidth: "170px"}} primary onClick={() => { 
                                        this.setState({ searchString: "HELLO" }, () => {
                                            const event = { target: { value: "HELLO" } };
                                            handleChangeSearchString(event);
                                        });
                                    }} >HELLO</Button>
                                </td>
                                </tr>
                                <tr className="tc pl2 pr2">
                                <td className={this.state.searchString === "C+C Ware" ? "selectedCategory pl2 pr2 tc" : "tc pl2 pr2"}>
                                    <Button style={{minWidth: "170px"}} primary onClick={() => { 
                                        this.setState({ searchString: "C+C Ware" }, () => {
                                            const event = { target: { value: "C+C Ware" } };
                                            handleChangeSearchString(event);
                                        });
                                    }} >C+C Ware</Button>
                                </td>
                                <td className={this.state.searchString === "lose Ware" ? "selectedCategory pl2 pr2 tc" : "tc pl2 pr2"}>
                                    <Button style={{minWidth: "170px"}} primary onClick={() => { 
                                        this.setState({ searchString: "lose Ware" }, () => {
                                            const event = { target: { value: "lose Ware" } };
                                            handleChangeSearchString(event);
                                        });
                                    }} >lose Ware</Button>
                                </td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}

                    <div className="pb3 pt2">
                    {/*<OrderDetailTable products={shop.delivery[0].positions} />*/}
                    {/*<ProductTable cart={shop.cart} onChange={this.handleChange} products={productSearch}/>*/}
                    </div>
                    <div className="pt3 pb3">
                    {productSearch.map( ( product, index ) => <ProductListItem
                                        history={this.props.history}
                                      index={index}
                                      key={product.map_id}
                                      product={product}
                                      additionalArticle={true}
                                      /> )}
                    </div>
                        {<div className="pt3">
                    <div className="tl">
                    <Link to={{
                    pathname: `/return/quantity`,
                    search  : this.props.location.search
                    }}>
                    <Button
                    primary >
                    {translate( "Zurück" )}
                    <i className="icon-angle-right"/>
                    </Button>
                    </Link>
                    <Button
                        className="fr"
                        disabled={false}
                        primary
                        onClick={() => {this.props.history.push("/return/contactPerson")}}
                        >{translate( "Zusatzsortimente bestätigen" )}</Button>
                    </div>
                    </div>}
                </td>
                </tr>
                </tbody>
            </table>
            </Responsive>
            <LocalFooter/>
            </Fragment>
        );
    }
}

let lastFilter = false

const getProducts = () => shop.cart.map( ( product ) => product)

export default ReturnPageQuantityAddons;


// WEBPACK FOOTER //
// ./src/theme/braunsheitmannShop/pages/returnCheckout/ReturnPageQuantityAddons.js